export default __webpack_public_path__ + "static/media/ts-7-4.00e7df26.svg";